// Renders one preview scenario via the real game-screen chrome + ActiveGameView.
// Header hidden so the top bar (cog + roster) sits at the top exactly like prod.
// A minimal floating back control (bottom-left) returns to the scenario list.
import { Stack, useLocalSearchParams, useRouter } from 'expo-router'
import { Pressable, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { PreviewGameScreen } from '../../../preview/PreviewGameScreen'
import { findScenario } from '../../../preview/scenarios'

export default function PreviewScenarioScreen() {
  const { scenario } = useLocalSearchParams<{ scenario: string }>()
  const router = useRouter()
  const insets = useSafeAreaInsets()
  const s = findScenario(scenario)

  if (!s) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <Stack.Screen options={{ title: 'Unknown preview' }} />
        <Text>Unknown scenario: {String(scenario)}</Text>
      </View>
    )
  }

  return (
    <View style={{ flex: 1 }}>
      <Stack.Screen options={{ headerShown: false }} />
      <PreviewGameScreen scenario={s} />
      <Pressable
        onPress={() => router.back()}
        accessibilityLabel="Back to scenario list"
        style={{
          position: 'absolute',
          bottom: insets.bottom + 8,
          left: 8,
          // Above the game's map/panel stack, which GameMapHost raises (zIndex 5)
          // and which reaches the screen bottom under these pills.
          zIndex: 1000,
          elevation: 1000,
          backgroundColor: 'rgba(0,0,0,0.55)',
          borderRadius: 16,
          paddingVertical: 5,
          paddingHorizontal: 12,
        }}
      >
        <Text style={{ color: '#fff', fontSize: 12, fontWeight: '600' }}>‹ Previews</Text>
      </Pressable>
    </View>
  )
}
